// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__uXxqo","info":"Note_info__1JOlu","note":"Note_note__e854z","actions":"Note_actions__1Z23K"};